export default {
  // プロフィール
  gender: [{ text: '女性', value: 'F' }, { text: '男性', value: 'M' }],
  blood: [
    { text: '', value: '' },
    { text: 'A型', value: 'A' },
    { text: 'B型', value: 'B' },
    { text: 'O型', value: 'O' },
    { text: 'AB型', value: 'AB' }
  ],
  marriage_status: [{ text: '未婚', value: '未婚' }, { text: '既婚', value: '既婚' }],
  from_pref: [
    { text: '', value: '' },
    { text: 'その他・不明', value: '不明' },
    { text: '北海道', value: '北海道' },
    { text: '青森県', value: '青森県' },
    { text: '岩手県', value: '岩手県' },
    { text: '宮城県', value: '宮城県' },
    { text: '秋田県', value: '秋田県' },
    { text: '山形県', value: '山形県' },
    { text: '福島県', value: '福島県' },
    { text: '茨城県', value: '茨城県' },
    { text: '栃木県', value: '栃木県' },
    { text: '群馬県', value: '群馬県' },
    { text: '埼玉県', value: '埼玉県' },
    { text: '千葉県', value: '千葉県' },
    { text: '東京都', value: '東京都' },
    { text: '神奈川県', value: '神奈川県' },
    { text: '新潟県', value: '新潟県' },
    { text: '富山県', value: '富山県' },
    { text: '石川県', value: '石川県' },
    { text: '福井県', value: '福井県' },
    { text: '山梨県', value: '山梨県' },
    { text: '長野県', value: '長野県' },
    { text: '岐阜県', value: '岐阜県' },
    { text: '静岡県', value: '静岡県' },
    { text: '愛知県', value: '愛知県' },
    { text: '三重県', value: '三重県' },
    { text: '滋賀県', value: '滋賀県' },
    { text: '京都府', value: '京都府' },
    { text: '大阪府', value: '大阪府' },
    { text: '兵庫県', value: '兵庫県' },
    { text: '奈良県', value: '奈良県' },
    { text: '和歌山県', value: '和歌山県' },
    { text: '鳥取県', value: '鳥取県' },
    { text: '島根県', value: '島根県' },
    { text: '岡山県', value: '岡山県' },
    { text: '広島県', value: '広島県' },
    { text: '山口県', value: '山口県' },
    { text: '徳島県', value: '徳島県' },
    { text: '香川県', value: '香川県' },
    { text: '愛媛県', value: '愛媛県' },
    { text: '高知県', value: '高知県' },
    { text: '福岡県', value: '福岡県' },
    { text: '佐賀県', value: '佐賀県' },
    { text: '長崎県', value: '長崎県' },
    { text: '熊本県', value: '熊本県' },
    { text: '大分県', value: '大分県' },
    { text: '宮崎県', value: '宮崎県' },
    { text: '鹿児島県', value: '鹿児島県' },
    { text: '沖縄県', value: '沖縄県' }
  ],
  birthorder: [
    { text: '', value: '' },
    { text: 'いちばん上', value: 'OLDEST' },
    { text: '真ん中', value: 'MIDDLE' },
    { text: '末っ子', value: 'YOUNGEST' },
    { text: 'ひとりっ子', value: 'ONLY' },
    { text: '不明', value: 'NONE' }
  ],
  relationship: [
    { text: '選択してください', value: '0', disabled: 'true' },
    { text: '好きな人がいない', value: '1' },
    { text: '好きな人がいる', value: '2' },
    { text: '恋人がいる', value: '3' },
    { text: '結婚している', value: '4' },
    { text: '答えたくない', value: '5' }
  ],

  // 相談内容
  love_status: [
    { text: '独身', value: '独身' },
    { text: '交際中', value: '交際中' },
    { text: '婚約中', value: '婚約中' },
    { text: '既婚', value: '既婚' },
    { text: 'その他', value: 'その他' }
  ],
  connection_period: [
    { text: '〜３ヶ月', value: '1' },
    { text: '〜１年', value: '2' },
    { text: '〜３年', value: '3' },
    { text: '３年〜', value: '4' }
  ],
  connection_count: [
    { text: '０名', value: '1' },
    { text: '〜２名', value: '2' },
    { text: '〜５名', value: '3' },
    { text: '６名以上', value: '4' }
  ],
  lover_search_period: [
    { text: '〜３ヶ月', value: '〜３ヶ月' },
    { text: '〜１年', value: '〜１年' },
    { text: '〜３年', value: '〜３年' },
    { text: '３年〜', value: '３年〜' }
  ],
  romance_history: [
    { text: '０名', value: '０名' },
    { text: '〜２名', value: '〜２名' },
    { text: '〜５名', value: '〜５名' },
    { text: '６名〜', value: '６名〜' }
  ],
  entry_genre: [
    { text: '選択してください', value: '' },
    { text: '出会いについて', value: '出会いについて' },
    { text: '仕事について', value: '仕事について' },
    { text: '結婚について', value: '結婚について' },
    { text: '金運について', value: '金運について' }
  ],
  order_genre: [
    { text: '選択してください', value: '' },
    { text: '出会いについて', value: '出会いについて' },
    { text: '仕事について', value: '仕事について' },
    { text: '結婚について', value: '結婚について' },
    { text: '金運について', value: '金運について' }
  ],
  has_partner: [{ text: 'いない', value: '0' }, { text: 'いる', value: '1' }],
  neko_theme: [
    { text: '選択してください', value: '' },
    { text: '恋愛', value: '1' },
    { text: '片想い', value: '2' },
    { text: '結婚', value: '3' },
    { text: '不倫／浮気', value: '4' },
    { text: '仕事', value: '5' },
    { text: 'お金', value: '6' },
    { text: '人生', value: '7' },
    { text: '人間関係', value: '8' }
  ]
}



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/FORM_OPTIONS.js